import { MarkerDimension, PropertySummary, SegObjectPropertyMap } from '../case/case.state'

/** Synthetic categorical property for multi-map color axis only (not X/Y). */
export const MAPPING_PROPERTY_NAME = 'intensity map'

export function isMappingProperty(name: string | null | undefined): boolean {
    return name === MAPPING_PROPERTY_NAME || name === 'mapping'
}

export function mappingPropertySummary(mapCount: number): PropertySummary {
    return {
        name: MAPPING_PROPERTY_NAME,
        lower_bound: 0,
        upper_bound: Math.max(mapCount - 1, 0),
    }
}

export function createMappingMarkerDimension(
    mapCount: number,
    propertyMap: SegObjectPropertyMap
): MarkerDimension {
    const summary = mappingPropertySummary(mapCount)
    return {
        name: MAPPING_PROPERTY_NAME,
        lower_bound: summary.lower_bound,
        upper_bound: summary.upper_bound,
        source_bin: '',
        source_json: '',
        segobjectpropertymap: propertyMap,
    }
}

/** Inject synthetic "intensity map" into a color-axis option list when multiple maps are loaded. */
export function withMappingProperty(
    catalog: PropertySummary[],
    loadedMapCount: number
): PropertySummary[] {
    const without = catalog.filter(p => !isMappingProperty(p.name))
    if (loadedMapCount <= 1) {
        return without
    }
    return [mappingPropertySummary(loadedMapCount), ...without]
}
